import { AzureOfferPlan } from '../../../modules/privateOffer/types'
import { useStyles } from './PlanMinMax.styles'
import {
  DetailInfo,
  DetailRow,
} from '../../../common/components/DetailRow/DetailRow'
import { useStyles as usePricingStyles } from '../MicrosoftViewPricing.styles'

interface PlanMinMaxProps {
  plan: AzureOfferPlan
}

export const PlanMinMax = ({ plan }: PlanMinMaxProps) => {
  const { classes } = useStyles()
  const { classes: pricingClasses } = usePricingStyles()

  const minUser = plan.pricing?.recurrentPrice?.userLimits?.min || '-'
  const maxUser = plan.pricing?.recurrentPrice?.userLimits?.max || '-'

  return (
    <div className={classes.container}>
      <div className={pricingClasses.subHeading}>Min-max users</div>
      <DetailRow
        borderBottom
        className={classes.rowItem}
        props={{ spacing: 4 }}
      >
        <>
          <DetailInfo
            title="Minimum users"
            value={String(minUser)}
            keyName="minUser"
            gridSize={4}
          />
          <DetailInfo
            title="Maximum users"
            value={String(maxUser)}
            keyName="maxUser"
          />
        </>
      </DetailRow>
    </div>
  )
}
